import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import About from './pages/About';
import Search from './pages/Search';
import ProjectDetail from './pages/ProjectDetail';
import Join from './pages/Join';
import BIM from './pages/BIM';
import PrefabBuilding from './pages/PrefabBuilding';
import GreenBuilding from './pages/GreenBuilding';

// 懒加载页面组件
const Staff = lazy(() => import('./pages/Staff'));
const Awards = lazy(() => import('./pages/Awards'));
const TechnologyPatents = lazy(() => import('./pages/TechnologyPatents'));

// 页面布局包装器
const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-grow">
      {children}
    </main>
    <Footer />
  </div>
);

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Routes>
          {/* 前台路由 */}
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/projects" element={<MainLayout><Projects /></MainLayout>} />
          <Route path="/projects/:id" element={<MainLayout><ProjectDetail /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/join" element={<MainLayout><Join /></MainLayout>} />
          <Route path="/search" element={<MainLayout><Search /></MainLayout>} />
          <Route path="/bim" element={<MainLayout><BIM /></MainLayout>} />
          <Route path="/prefab-building" element={<MainLayout><PrefabBuilding /></MainLayout>} />
          <Route path="/green-building" element={<MainLayout><GreenBuilding /></MainLayout>} />
          <Route path="/staff" element={
            <MainLayout>
              <Suspense fallback={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              }>
                <Staff />
              </Suspense>
            </MainLayout>
          } />
          <Route path="/awards" element={
            <MainLayout>
              <Suspense fallback={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              }>
                <Awards />
              </Suspense>
            </MainLayout>
          } />
          <Route path="/technology-patents" element={
            <MainLayout>
              <Suspense fallback={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              }>
                <TechnologyPatents />
              </Suspense>
            </MainLayout>
          } />

          {/* 404页面 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
};

export default App;